// takes config from window.appConfig
export default {
  eventId: window.appConfig.event ? window.appConfig.event.id : null,
  eventSlug: window.appConfig.event ? window.appConfig.event.slug : null,
}

// returns company id by slug
export const getCompanyId = (slug) => {
  let company = window.appConfig.companies.find( (c) => ((c.slug == slug) || (c.id == slug)) );
  return company ? company.id : slug;
}
